import { SessionState } from '../../../types';


function GetCurrentUser() {
    const user = localStorage.getItem('currentSalesPediaUser');
    const resp: SessionState = user != null ? JSON.parse(JSON.parse(JSON.stringify(user.toString()))) : user;
    return resp;
}

function SetCurrentUser(user: string) {
    localStorage.setItem('currentSalesPediaUser', user);
}

export default {
    GetCurrentUser,
    SetCurrentUser
};


